export enum ColorType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  DARK = 'dark',
  MEDIUM = 'medium',
  LIGHT = 'light',
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
}
